import React from "react";
import { useTranslation } from "react-i18next";
import { formatStatusList } from "health/healthStatusCopy";
import useHealthModule from "health/useHealthModule";
import readableHealthAlertTarget from "./readableTarget";
const HealthAlertEventDefinitionSummary = ({ config }) => {
  const { t } = useTranslation("enterprise_license");
  const { paths } = useHealthModule();
  if (!config) return null;
  const typedConfig = config;
  return /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("dt", null, t("health.alert.health_check")), /* @__PURE__ */ React.createElement("dd", null, typedConfig.targets.map((target) => readableHealthAlertTarget(target, paths)).join(", ")), /* @__PURE__ */ React.createElement("dt", null, t("health.alert.alert_when")), /* @__PURE__ */ React.createElement("dd", null, formatStatusList(typedConfig.statuses)));
};
export default HealthAlertEventDefinitionSummary;
